// extracted by mini-css-extract-plugin
export default {"link":"LoginLayout_link__JBBlU"};